import { Heading, Layout, Text } from '../../../components/core';
import { PageContent, PageError, PageHeader, PageLoading } from '../../../components/page';
import {
  useFetchSurveyAnalyticsConsentContent2Query,
  HubConsentContentType,
} from '../../../graphQL';
import { useTitle } from '../../../utils/useTitle';

export const SurveyAnalyticsConsentPage = (): JSX.Element => {
  useTitle(['Survey Analytics Consent']);
  const { data, loading } = useFetchSurveyAnalyticsConsentContent2Query();

  if (loading) {
    return <PageLoading pageName="survey analytics consent" />;
  }

  if (data?.fetchSurveyAnalyticsConsentContent2 === undefined) {
    return <PageError />;
  }

  const { pageTitle, contentSections } = data.fetchSurveyAnalyticsConsentContent2;

  return (
    <PageContent testID="survey-analytics-consent-page">
      <PageHeader title={pageTitle} />

      <Layout.VStack space={4}>
        {contentSections.map((section, index) => {
          if (
            section.__typename === 'HubConsentContentHeaderSection' &&
            section.type === HubConsentContentType.Heading
          ) {
            return (
              <Heading.h4 key={index} level={2}>
                {section.headerContent}
              </Heading.h4>
            );
          }

          if (
            section.__typename === 'HubConsentContentParagraphSection' &&
            section.type === HubConsentContentType.Paragraph
          ) {
            return <Text.paraSmall key={index}>{section.paragraphContent}</Text.paraSmall>;
          }

          return null;
        })}
      </Layout.VStack>
    </PageContent>
  );
};
